import React, { Fragment } from "react";
import H3Text from "@Uilib/h3Text";
import H3FormInput from "@Uilib/h3FormInput";
import { QUANTITY } from "@Apis/constants";
import { Tooltip } from "antd";

const GRNLineSplitStatus = ({
  statuses,
  formSubmitted,
  record,
  onChangeStatusQty,
}) => {
  return (
    <Fragment>
      <div className="create-grn-table__input">
        {statuses?.length > 0 && (
          <div
          className="create-grn-table__input-wrapper create-grn-table__input-wrapper-small-2"
          style={{ marginBottom: "3px" }}
        >
          <H3Text text="Pending" className="create-grn-table__input-label" />
          &nbsp;
          <div style={{ width: "70px" }}>
            {QUANTITY(
              record?.pending_quantity || 0,
              record?.uom_info?.[0]?.precision
            )}
            &nbsp;
          </div>
          &nbsp;
          <H3FormInput
            labelClassName="orgFormLabel"
            inputClassName={`orgFormInput ${
              formSubmitted &&
                Number(record?.lineStatusPendingQty) < 0
                ? "orgFormInputError"
                : ""
            } `}
            value={record?.lineStatusPendingQty || 0}
            name="unit price"
            type="number"
            onChange={(e) =>
              onChangeStatusQty(e.target.value, null, 'lineStatusPendingQty')
            }
          />
          &nbsp;
          <div>{record?.uom_info?.[0]?.uqc?.toProperCase()}</div>
          &nbsp;
          </div>
      )}
      </div>
      {statuses?.map((status) => (
        <div className="create-grn-table__input">
          <div
            className="create-grn-table__input-wrapper create-grn-table__input-wrapper-small-2"
            style={{ marginBottom: "3px" }}
          >
            <Tooltip title={status?.status_name}>
              <div className="create-grn-table__input-label">{status?.status_name}</div>
            </Tooltip>
            &nbsp;
            <div style={{ width: "70px" }}>
              {QUANTITY(status?.quantity, record?.uom_info?.[0]?.precision)}
              &nbsp;
            </div>
            &nbsp;
            <H3FormInput
              labelClassName="orgFormLabel"
              inputClassName={`orgFormInput ${
                (status?.line_status_received_qty < 0 ||
                  status?.line_status_received_qty > status?.quantity)
                  ? "orgFormInputError"
                  : ""
              } `}
              value={status?.line_status_received_qty || 0}
              name="unit price"
              type="number"
              onChange={(e) =>
                onChangeStatusQty(e.target.value, status?.po_line_status_id)
              }
            />
            &nbsp;
            <div>{record?.uom_info?.[0]?.uqc?.toProperCase()}</div>
          </div>
        </div>
      ))}
    </Fragment>
  );
};

export default GRNLineSplitStatus;
